export const keysOfRecoil = {
  native: {
    appVersion: 'native-appVersion',
  },
  modal: {
    center: 'center',
  },
};
